/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dashfix_Routing_One_FailoverInputs */

const en_dashfix_routing_one_failover = /** @type {(inputs: Dashfix_Routing_One_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lane · auto failover`)
};

const zh_hans1_dashfix_routing_one_failover = /** @type {(inputs: Dashfix_Routing_One_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个数据源 · 自动切换`)
};

const pt_br2_dashfix_routing_one_failover = /** @type {(inputs: Dashfix_Routing_One_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fonte · failover automático`)
};

const es_dashfix_routing_one_failover = /** @type {(inputs: Dashfix_Routing_One_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fuente · respaldo automático`)
};

const fr_dashfix_routing_one_failover = /** @type {(inputs: Dashfix_Routing_One_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} source · basculement auto`)
};

const de_dashfix_routing_one_failover = /** @type {(inputs: Dashfix_Routing_One_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Quelle · automatisches Failover`)
};

const ru_dashfix_routing_one_failover = /** @type {(inputs: Dashfix_Routing_One_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} источник · автоматическое переключение`)
};

const it_dashfix_routing_one_failover = /** @type {(inputs: Dashfix_Routing_One_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fonte · failover automatico`)
};

/**
* | output |
* | --- |
* | "{count} lane · auto failover" |
*
* @param {Dashfix_Routing_One_FailoverInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const dashfix_routing_one_failover = /** @type {((inputs: Dashfix_Routing_One_FailoverInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashfix_Routing_One_FailoverInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_dashfix_routing_one_failover(inputs)
	if (locale === "pt-BR") return pt_br2_dashfix_routing_one_failover(inputs)
	if (locale === "es") return es_dashfix_routing_one_failover(inputs)
	if (locale === "fr") return fr_dashfix_routing_one_failover(inputs)
	if (locale === "de") return de_dashfix_routing_one_failover(inputs)
	if (locale === "ru") return ru_dashfix_routing_one_failover(inputs)
	if (locale === "it") return it_dashfix_routing_one_failover(inputs)
	return en_dashfix_routing_one_failover(inputs)
});